import { render, staticRenderFns } from "./AddCollection.vue?vue&type=template&id=5f0878d0&scoped=true"
import script from "./AddCollection.vue?vue&type=script&lang=js"
export * from "./AddCollection.vue?vue&type=script&lang=js"
import style0 from "./AddCollection.vue?vue&type=style&index=0&id=5f0878d0&prod&scoped=true&lang=css"
import style1 from "./AddCollection.vue?vue&type=style&index=1&id=5f0878d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0878d0",
  null
  
)

export default component.exports